var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "sidebar-item" }, [
      _c("div", { staticClass: "runs-container" }, [
        _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active: _vm.imageIndex < 0 && _vm.activeStage.preview === true,
            },
            on: {
              click: function ($event) {
                return _vm.chooseActiveStage()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-space-between image-container-sample",
              },
              [
                _c("img", {
                  staticClass: "sys-img",
                  attrs: {
                    src: _vm.getImageFromStorage(
                      this.activeStage.mainJob?.apiJob?.output[0].uri
                    ),
                  },
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("trans")("Original")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _vm.index > 2
                ? _c("span", { staticClass: "badge badge-pro" }, [
                    _vm._v(_vm._s(_vm._f("trans")("PRO"))),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active:
                    _vm.imageIndex < 0 && _vm.activeStage.preview === true,
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-item" }, [
      _c(
        "div",
        { staticClass: "runs-container" },
        _vm._l(4, function (index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "runs-btn",
              class: {
                disabled: index > 2 && _vm.isProAndAboveUser === false,
                active:
                  _vm.imageIndex === index - 1 &&
                  _vm.activeStage.preview === true,
              },
              on: {
                click: function ($event) {
                  return _vm.chooseImage(index - 1)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-space-between image-container-sample",
                },
                [
                  _vm.currentJob.getActiveStageJob().sysJobs?.length === 0 &&
                  index < 3 &&
                  _vm.isProAndAboveUser === false
                    ? _c("div", { staticClass: "loading h-100" }, [
                        _c("img", { attrs: { src: _vm.loadingImage } }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentJob.getActiveStageJob().sysJobs?.length === 0 &&
                  _vm.isProAndAboveUser === true
                    ? _c("div", { staticClass: "loading h-100" }, [
                        _c("img", { attrs: { src: _vm.loadingImage } }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentJob.getActiveStageJob().sysJobs?.length > 0 &&
                  index < 3 &&
                  _vm.isProAndAboveUser === false
                    ? _c("img", {
                        staticClass: "sys-img",
                        attrs: {
                          src: _vm.getImageFromStorage(
                            _vm.currentJob.getActiveStageJob().sysJobs[0]
                              ?.apiJob.output[index - 1].uri
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentJob.getActiveStageJob().sysJobs?.length > 0 &&
                  _vm.isProAndAboveUser === true
                    ? _c("img", {
                        staticClass: "sys-img",
                        attrs: {
                          src: _vm.getImageFromStorage(
                            _vm.currentJob.getActiveStageJob().sysJobs[0]
                              ?.apiJob.output[index - 1].uri
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  index > 2 && _vm.isProAndAboveUser === false
                    ? _c("div", { staticClass: "no-pro-thumb" }, [
                        _c("i", { staticClass: "far fa-image" }),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n\n          Variation " + _vm._s(index) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", [
                index > 2
                  ? _c("span", { staticClass: "badge badge-pro" }, [
                      _vm._v(_vm._s(_vm._f("trans")("PRO"))),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkmark-box",
                  class: {
                    disabled: index > 2 && _vm.isProAndAboveUser === false,
                    active:
                      _vm.imageIndex === index - 1 &&
                      _vm.activeStage.preview === true,
                  },
                },
                [_c("i", { staticClass: "fa fa-check" })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }